var React = require('react');

function PrevArrowDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_85","data-name":"Path 85","d":"M303.5,2530l-11-11,11-11","transform":"translate(-290.379 -2506.939)","fill":"none","stroke":"#0C2340","strokeMiterlimit":"10","strokeWidth":"3","fillRule":"evenodd"}));
}

PrevArrowDark.defaultProps = {"width":"14.182","height":"24.121","viewBox":"0 0 14.182 24.121"};

module.exports = PrevArrowDark;

PrevArrowDark.default = PrevArrowDark;
